import React from 'react'
import GetMarks from '../components/instructor/GetMarks'
import Navbar from '../components/Navbar/Navbar'
import ForgotPassword from '../components/forgotPassword/ForgotPassword'

const ForgotPasswordPage = () => {
  return (
    <div>
      <Navbar/>
       <ForgotPassword/>
    </div>
  )
}

export default ForgotPasswordPage